<template>
    <Navbar />
    <div v-if="updateAvailable" class="update-banner">
        Nova versão disponível
        <button type="button" class="btn btn-sm btn-primary" @click="applyUpdate">Atualizar</button>
    </div>
    <div
        v-if="impersonating"
        class="impersonation-banner"
        :class="{ 'below-update': updateAvailable }"
    >
        Logado como {{ current_user?.nome }}.
        <button type="button" class="btn btn-sm btn-primary" @click="voltarAoMaster" :disabled="stopping">
            Voltar ao Master
        </button>
    </div>
    <main class="container-- bg-white">
        
        <router-view></router-view>
        <UseNetwork v-slot="{ isOnline }" >
            <div class="is-online badge bg-success" v-if="isOnline">ONLINE: {{ user }}</div>
            <div class="is-offline badge bg-danger" v-if="!isOnline">OFFLINE: {{ user }}</div>

        </UseNetwork>
    </main>
</template>
<script>
import { UseNetwork } from '@vueuse/components';
import Navbar from '../components/Navbar.vue';
import Saudacao from '../components/Saudacao.vue';
import { current_user, impersonating, stopImpersonate } from '@/store/auth';
import { updateAvailable, applyUpdate } from '@/lib/update-checker';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';

export default {
    components: {
        Navbar,
        Saudacao,
        UseNetwork
    },
    setup() {
        const router = useRouter()
        const stopping = ref(false)

        watch(updateAvailable, (on) => {
            document.body.classList.toggle('has-update-banner', on)
        }, { immediate: true })

        watch(impersonating, (on) => {
            document.body.classList.toggle('has-impersonation-banner', on)
        }, { immediate: true })

        const voltarAoMaster = async () => {
            stopping.value = true
            try {
                await stopImpersonate()
                router.replace('/usuarios')
            } finally {
                stopping.value = false
            }
        }

        return {
            updateAvailable,
            applyUpdate,
            impersonating,
            current_user,
            stopping,
            voltarAoMaster,
        }
    },
    computed: {
        user() {
            return current_user?.value?.nome || ''
        }
    },
    mounted() {
        document.body.classList.add("default-page");
        document.body.classList.add("bg-light");
    },
    unmounted() {
        document.body.classList.remove("default-page");
        document.body.classList.remove("bg-light");
        document.body.classList.remove("has-update-banner");
        document.body.classList.remove("has-impersonation-banner");
    }
};
</script>
<style lang="less">
.update-banner,
.impersonation-banner {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 1020;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    min-height: 40px;
    padding: 0.35rem 1rem;
    background: rgba(var(--bs-primary-rgb), 0.12);
    color: var(--bs-primary);
    border-bottom: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    font-size: 0.875rem;
    font-weight: 500;
}
.update-banner {
    top: 56px;
}
.impersonation-banner {
    top: 56px;
    &.below-update {
        top: 96px;
    }
}
.is-online,.is-offline {
    position: fixed;
    bottom: 1em;
    right: 1em;
    pointer-events: none;
}
.is-online {
    background-color: green;
}
.is-online {
    background-color: red;
}

body.default-page {
    padding-top: 56px;
    &.has-update-banner {
        padding-top: 96px;
        @media (max-width: 991.98px) {
            .offcanvas-collapse {
                top: 96px;
            }
        }
    }
    &.has-impersonation-banner {
        padding-top: 96px;
        @media (max-width: 991.98px) {
            .offcanvas-collapse {
                top: 96px;
            }
        }
    }
    &.has-update-banner.has-impersonation-banner {
        padding-top: 136px;
        @media (max-width: 991.98px) {
            .offcanvas-collapse {
                top: 136px;
            }
        }
    }
    @media (max-width: 991.98px) {
        .offcanvas-collapse {
            position: fixed;
            top: 56px; /* Height of navbar */
            bottom: 0;
            left: 100%;
            width: 100%;
            padding-right: 1rem;
            padding-left: 1rem;
            overflow-y: auto;
            visibility: hidden;
            background-color: #343a40;
            transition: transform 0.3s ease-in-out, visibility 0.3s ease-in-out;
            &.open {
                visibility: visible;
                transform: translateX(-100%);
            }
        }

    }
    .nav-scroller {
        position: relative;
        z-index: 2;
        height: 2.75rem;
        overflow-y: hidden;
        .nav {
            display: flex;
            flex-wrap: nowrap;
            padding-bottom: 1rem;
            margin-top: -1px;
            overflow-x: auto;
            color: rgba(255, 255, 255, 0.75);
            text-align: center;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
        }
    }
    .nav-underline {
        .nav-link {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
            font-size: 0.875rem;
            color: #6c757d;
            &:hover {
                color: #007bff;
            }
            &.active {
                font-weight: 500;
                color: #343a40;
            }
        }
    }
    .bg-purple {
        background-color: #6f42c1;
    }
}
</style>
